import { ApiResult, post } from '@/utils/api';
import { ResultModel } from '@/model/viewModel';
import { FoodCategoryDetailModel, FoodDetailModel, FoodTagDetailModel } from '@/model/food';

export interface FoodStockImportItemModel {
  foodId: number;
  stockQuantity: number;
}

export interface FoodStockImportRequestModel {
  stockList: FoodStockImportItemModel[];
}

export interface FoodStockImportResultModel {
  foodIds: number[];
}

export const outFood = (data: any): Promise<ApiResult<number>> =>
  post<number>('/order/out/complete/out', data);

export const foodUp = (data: any): Promise<ApiResult<number>> =>
  post<number>('/order/out/complete/up', data);

export const fetchCategoryList = (data: any): Promise<ApiResult<ResultModel<any>>> =>
  post<ResultModel<any>>('/shop/food/category/select', data);

export const fetchCategoryItemList = (data: any): Promise<ApiResult<ResultModel<any>>> =>
  post<ResultModel<any>>('/shop/food/select', data);

export const initializeFood = (data: any): Promise<ApiResult<number>> =>
  post<number>('/shop/food/initialInsert', data);

export const updateFood = (data: any): Promise<ApiResult<number>> =>
  post<number>('/shop/food/initialEdit', data);

export const initializeFoodStock = (
  data: FoodStockImportRequestModel,
): Promise<ApiResult<FoodStockImportResultModel>> =>
  post<FoodStockImportResultModel>('/shop/food/initialStock', data);

export const forbidFood = (data: any): Promise<ApiResult<number>> =>
  post<number>('/shop/food/forbid', data);

export const fetchFoodDetail = (data: any): Promise<ApiResult<FoodDetailModel>> =>
  post<FoodDetailModel>('/shop/food/selectOne', data);

export const addFoodCategory = (data: any): Promise<ApiResult<number>> =>
  post<number>('/shop/food/category/insert', data);

export const updateFoodCategory = (data: any): Promise<ApiResult<number>> =>
  post<number>('/shop/food/category/edit', data);

export const deleteFoodCategory = (data: any): Promise<ApiResult<number>> =>
  post<number>('/shop/food/category/delete', data);

export const forbidFoodCategory = (data: any): Promise<ApiResult<number>> =>
  post<number>('/shop/food/category/forbid', data);

export const fetchFoodCategoryDetail = (data: any): Promise<ApiResult<FoodCategoryDetailModel>> =>
  post<FoodCategoryDetailModel>('/shop/food/category/selectOne', data);

export const fetchTagList = (data: any): Promise<ApiResult<ResultModel<any>>> =>
  post<ResultModel<any>>('/shop/food/tag/select', data);

export const fetchTagDetail = (data: any): Promise<ApiResult<FoodTagDetailModel>> =>
  post<FoodTagDetailModel>('/shop/food/tag/selectOne', data);

export const addTag = (data: any): Promise<ApiResult<number>> =>
  post<number>('/shop/food/tag/insert', data);

export const updateTag = (data: any): Promise<ApiResult<number>> =>
  post<number>('/shop/food/tag/edit', data);

export const deleteTag = (data: any): Promise<ApiResult<number>> =>
  post<number>('/shop/food/tag/delete', data);

export const forbidTag = (data: any): Promise<ApiResult<number>> =>
  post<number>('/shop/food/tag/forbid', data);

export const fetchCategoryTagList = (data: any): Promise<ApiResult<ResultModel<any>>> =>
  post<ResultModel<any>>('/shop/food/category/selectCategoryTag', data);

export const insertLanguageTranslation = (data: any): Promise<ApiResult<number>> =>
  post<number>('/dim/language/translation/insert', data);

export const updateLanguageTranslation = (data: any): Promise<ApiResult<number>> =>
  post<number>('/dim/language/translation/edit', data);

export const fetchLanguageTranslationList = (data: any): Promise<ApiResult<ResultModel<any>>> =>
  post<ResultModel<any>>('/dim/language/translation/select', data);
